// extracted by mini-css-extract-plugin
export default {"row":"Row_row__sz8DB","number":"Row_number__EGOFB","status":"Row_status__QiZDo","col":"Row_col__qBtki","item":"Row_item__D-4vK","copy_icon":"Row_copy_icon__XutOv"};